import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  SixToNineAmBlue,
  NineToTwelveAmBlue,
  TwelveToThreePmBlue,
  ThreeToSixPmBlue,
  SixToNinePmBlue,
  NineToTwelvePmBlue,
} from "../../constant/imagePath";
import classes from "./timeOfTheDay.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { ReactSVG } from "react-svg";

const Box = ({ item, onClick, isSelected }) => {
  return (
    <div
      className={`${[classes.box].join(" ")}`}
      onClick={() =>
        onClick({ id: item.id, time: item?.time, tagline: item?.tagline })
      }
    >
      <ReactSVG
        src={item?.icon}
        beforeInjection={(svg) => {
          svg.classList.add(
            `${[isSelected ? classes.img : classes.svgContainer].join(" ")}`
          );
        }}
      />
      {/* <img
        src={item?.icon}
        className={`${[!isSelected && classes.img].join(" ")}`}
      /> */}
      <h6 style={{ ...Fonts.h8, color: Colors.neutralShadesOfNero }}>
        {item?.time}
      </h6>
      <span style={{ ...Fonts.p4, color: Colors.neutralShadesOfDimGray }}>
        {item?.tagline}
      </span>
    </div>
  );
};

export const TimeOfTheDay = ({
  totalDays,
  totalTimings,
  selectedDays,
  setSelectedDays,
  selectedTimings,
  setSelectedTimings,
  showButtons = true,
  containerClass,
}) => {
  // For Day Selection
  function selectDay(day) {
    const newArray = [...selectedDays];
    if (selectedDays?.includes(day)) {
      const index = selectedDays?.indexOf(day);
      newArray.splice(index, 1);
    } else {
      newArray.push(day);
    }
    setSelectedDays(newArray);
  }
  // For Time Selection
  function selectTimings(item) {
    const newArray = [...selectedTimings];
    if (selectedTimings?.findIndex((e) => e.id === item.id) !== -1) {
      const index = selectedTimings?.findIndex((e) => e.id === item.id);
      newArray.splice(index, 1);
    } else {
      newArray.push(item);
    }
    setSelectedTimings(newArray);
  }

  // For Checking If the Time is Selected
  function isSelectedTiming(item) {
    if (selectedTimings?.findIndex((e) => e.id === item.id) !== -1) return true;
    else return false;
  }

  return (
    <div
      className={`${[classes.container, containerClass && containerClass].join(
        " "
      )}`}
      style={{ backgroundColor: Colors.white }}
    >
      {/* Styles */}
      <style jsx>{`
        .${classes.img} path {
          stroke: ${Colors.mainBlue};
        }
        .${classes.svgContainer} path {
          stroke: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
      {/* End of styles */}
      <div className={`${[classes.contentBox]}`}>
        <h6
          style={{
            ...Fonts.h7,
            lineHeight: "24px",
            fontFamily: "inter-600",
            color: Colors.neutralShadesOfNero,
          }}
        >
          Time of the day
        </h6>
        {/* Timings Box */}
        <div className={`${[classes.timingsBox].join(" ")}`}></div>

        {/* Table */}
        <table>
          <tr>
            {totalTimings?.slice(0, 3)?.map((item, i) => {
              return (
                <td
                  style={
                    i === 0
                      ? {
                          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                          borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                      : i === 2
                      ? {
                          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                          borderLeft: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                      : {
                          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                  }
                >
                  <Box
                    item={item}
                    onClick={selectTimings}
                    isSelected={isSelectedTiming(item)}
                  />
                </td>
              );
            })}
          </tr>
          <tr>
            {totalTimings?.slice(3)?.map((item, i) => {
              return (
                <td
                  style={
                    i === 0
                      ? {
                          borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                      : i === 2
                      ? {
                          borderLeft: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                      : {
                          borderRight: `1px solid ${Colors.neutralShadesOfWhisper}`,
                        }
                  }
                >
                  <Box
                    item={item}
                    onClick={selectTimings}
                    isSelected={isSelectedTiming(item)}
                  />
                </td>
              );
            })}
          </tr>
        </table>
        {/* Days */}
        <h6 style={{ ...Fonts.h8, color: Colors.neutralShadesOfNero }}>
          Days of week
        </h6>
        {/* Days List */}
        <div className="d-flex" style={{ marginTop: "16px", flexWrap: "wrap" }}>
          {totalDays?.map((item) => {
            const btnStyle = {
              padding: "8px 16px",
              ...Fonts.p2,
              marginRight: "10px",
              width: "44px",
              height: "36px",
            };
            return (
              <Button
                customStyle={
                  selectedDays?.includes(item)
                    ? {
                        ...btnStyle,
                        backgroundColor: Colors.neutralShadesOfNero,
                        color: Colors.white,
                      }
                    : {
                        ...btnStyle,
                      }
                }
                onClick={() => selectDay(item)}
              >
                {item}
              </Button>
            );
          })}
        </div>
      </div>
      {/* Buttons */}
      {showButtons && (
        <div
          className={`${[classes.btnsBox].join(" ")}`}
          style={{ borderTop: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        >
          <LinkButtonWithIcon
            onClick={() => {
              setSelectedTimings([]);
              setSelectedDays([]);
            }}
            text={"Clear"}
            primary={false}
            textColor={Colors.neutralShadesOfNero}
            customStyle={{
              ...Fonts.b2,
              lineHeight: "20px",
            }}
          />

          <Button
            primary={true}
            size={"Medium"}
            customStyle={{
              padding: "8px 16px",
              borderRadius: "8px",
              width: "64px",
              height: "36px",
            }}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

TimeOfTheDay.propTypes = {
  totalDays: PropTypes.array,
  totalTimings: PropTypes.array,
  selectedDays: PropTypes.array,
  selectedTimings: PropTypes.array,
  setSelectedTimings: PropTypes.func,
  setSelectedDays: PropTypes.func,
};
TimeOfTheDay.defaultProps = {
  totalDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  totalTimings: [
    { id: 1, icon: SixToNineAmBlue, time: "6-9 am", tagline: "Morning" },
    {
      id: 2,
      icon: NineToTwelveAmBlue,
      time: "9-12 am",
      tagline: "Late Morning",
    },
    { id: 3, icon: TwelveToThreePmBlue, time: "12-3 pm", tagline: "Afternoon" },
    {
      id: 4,
      icon: ThreeToSixPmBlue,
      time: "3-6 pm",
      tagline: "Late Afternoon",
    },
    { id: 5, icon: SixToNinePmBlue, time: "6-9 pm", tagline: "Evening" },
    {
      id: 6,
      icon: NineToTwelvePmBlue,
      time: "9-12 pm",
      tagline: "Late Evening",
    },
  ],
  selectedTimings: [{ id: 1, time: "6-9 am", tagline: "Morning" }],
  selectedDays: ["Sun"],
};
